import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  viboList: {
    '&:not(.gridView)': {
      display: 'flex',
      flexDirection: 'column',
    },

    '&.gridView': {
      display: 'grid',
      gap: 'var(--gap-sm)',
      gridTemplateColumns: 'repeat(var(--cols-sm), 1fr)',

      '@media screen and (min-width: 1441px)': {
        gap: 'var(--gap-lg)',
        gridTemplateColumns: 'repeat(var(--cols-lg), 1fr)',
      },
    },
  },

  spinner: {
    color: 'var(--primary-main)',
  },
}));

export default useStyles;
